import React, { useState } from "react";
import { defaultStyles } from "../../../constants/style-constants/utils";
// import Modal from "./Modal";
import helpIcon from "../../../assets/images/DeathModuleNew/IC_Help.png";
import { Button } from "../../../components/styled-components/button";
import fileIcon from "../../../assets/images/DeathModuleNew/Icons.png";
import Loader from "../../../components/styled-components/loader/loader";
import * as Style from "../styles/ModalStyle";
import { Icon, Modal, Select, Row, Col, Radio, Input } from "antd";
import Currency from "../../../components/form/Currency";
import { InputGroup } from "../../../components/inputGroup/InputGroup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import PhoneNum from "../../../components/form/components/Countrycode";
import TextArea from "antd/lib/input/TextArea";
import WebAddress from "../../../components/form/WebAddress";
import swal from "sweetalert";
import { DatePicker } from "antd";
import DEATH_API from "../../../apis/death.api";
import { AutoComplete } from 'antd';
const { Option } = Select;

function AddModal({
  show,
  close,
  fields,
  submitData,
  modalTitle,
  handlechange,
  handleDocumentChange,
  handleDatePickerChange,
  handleRadioChange,
  handlePhoneChange,
  handleSelectChange,
  handleRichTextChange,
  handleSelectTemplateChange,
  handleSelectTextTemplateChange,
  handleCurrencychange,
}) {
  const { styles } = defaultStyles;
  const [formData, setFormData] = useState({});
  const [textField, setTextField] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [templateDesign, setTemplateDesign] = useState("");
  const [tooltipModalTrustee, setTooltipModalTrustee] = useState(false);
  const [tooltipModalPassword, setTooltipModalPassword] = useState(false);
  const [tooltipModalTeam, setTooltipModalTeam] = useState(false);

  const dataSource = ['Burns Bay Road', 'Downing Street', 'Wall Street'];

  const [requiredFields, setRequiredFields] = useState(null);
  console.log("fields newww", fields);
  const [selectListCustomtext, setselectListCustomtext] = useState({});
  const handleSubmit = () => {
    submitData();
    setFormData({});
    // close();
  };
  const showTooltipModalTrustee = () => {
    setTooltipModalTrustee(true);
  };

  const handleTooltipCancelTrustee = () => {
    setTooltipModalTrustee(false);
  };

  const showTooltipModalPassword = () => {
    setTooltipModalPassword(true);
  };

  const handleTooltipCancelPassword = () => {
    setTooltipModalPassword(false);
  };

  const showTooltipModalTeam = () => {
    setTooltipModalTeam(true);
  };

  const handleTooltipCancelTeam = () => {
    setTooltipModalTeam(false);
  };

  console.log("show....", show);
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  for (let i = 0; i < fields.length; i++) {
    console.log("fieldssssssasasdasdsa", fields[i]);
  }
  return (
    <Modal footer={null} closable={false} visible={show} centered>
      {console.log("show in modal", show)}
      <Style.HeaderConatiner>
        <Style.ModalTitle> {modalTitle}</Style.ModalTitle>
        {/* <Icon type="close" onClick={close}></Icon> */}
      </Style.HeaderConatiner>

      <div
        style={{
          marginTop: "1rem",
          maxHeight: "25rem",
          overflow: "scroll",
          padding: "1rem",
        }}>
        {fields.map((item, idx) => {
          const {
            title,
            type,
            options = [],
            index = null,
            isRequired = false,
            def = null,
            isDisabled = false,
          } = item;
          switch (type) {
            case "email":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    defaultValue={def}
                    name={item.title}
                    value={null}
                    pattern="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i"
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e);
                    }}
                    // onChange={(val) => {
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                </div>
              );
            case "input":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>
                    {modalTitle === "Add New Contact" &&
                      item.title === "First Name" ||
                        item.title === "Last Name"
                     ? (
                      <React.Fragment>
                        {item.title}
                        <span style={{ color: "red" }}>*</span>
                      </React.Fragment>
                    ) : (
                      item.title 
                    )}
                  </Style.FieldsTitle>
                  {title === "2FA" ? (
                    <Style.Input
                      defaultValue={null}
                      disabled={isDisabled}
                      value={null}
                      // name={index}
                      name={item.title}
                      onChange={(e) => {
                        e.preventDefault();

                        handlechange(e);
                      }}
                      // onChange={(val) => {
                      //   if (currentForm) {
                      //     handleInputChange(val, currentForm);
                      //     setFormData({
                      //       [index]: val.target.value,
                      //     });
                      //   } else {
                      //     this.setState({
                      //       form: {
                      //         ...this.state.form,
                      //         [index]: val.target.value,
                      //       },
                      //     });
                      //   }
                      // }}
                      size="large"
                      placeholder={`Google Auth, YubiKey, SMS/Text, etc.`}
                      // name="client_primaryContactNumber"
                    ></Style.Input>
                  ) : (
                    <React.Fragment>
                      <Style.Input
                        defaultValue={null}
                        disabled={isDisabled}
                        value={null}
                        // name={index}
                        name={item.title}
                        onChange={(e) => {
                          e.preventDefault();
                          e.persist();
                          if (
                            item.title === "First Name" ||
                            item.title === "Last Name" 
                            // ||
                            // item.title === "Subject"
                          ) {
                            setRequiredFields({
                              ...requiredFields,
                              [e.target.name]: e.target.value,
                            });
                          }
                          handlechange(e);
                        }}
                        // onChange={(val) => {
                        //   if (currentForm) {
                        //     handleInputChange(val, currentForm);
                        //     setFormData({
                        //       [index]: val.target.value,
                        //     });
                        //   } else {
                        //     this.setState({
                        //       form: {
                        //         ...this.state.form,
                        //         [index]: val.target.value,
                        //       },
                        //     });
                        //   }
                        // }}
                        size="large"
                        placeholder={`Enter ${title}`}
                        required={true}></Style.Input>
                    </React.Fragment>
                  )}
                </div>
              );
            case "emails":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>
                    {modalTitle === "Add New Contact" ||
                    (modalTitle === "Add New Email" &&
                      item.title === "Email") ||
                    item.title === "To" ? (
                      <React.Fragment>
                        {" "}
                        {item.title}
                        <span style={{ color: "red" }}>*</span>
                      </React.Fragment>
                    ) : (
                      item.title
                    )}
                  </Style.FieldsTitle>
                  <Style.Input
                    // className="custom-input"
                    defaultValue={def}
                    disabled={isDisabled}
                    value={null}
                    name={index}
                    pattern="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i"
                    onChange={(e) => {
                      e.preventDefault();
                      e.persist();
                      if (!isValidEmail(e.target.value)) {
                        setError("Email is invalid");
                      } else {
                        setError(null);
                      }
                      if (item.title === "Email" || item.title === "To") {
                        setRequiredFields({
                          ...requiredFields,
                          [e.target.name]: e.target.value,
                        });
                      }
                      setEmail(e.target.value);
                      handlechange(e);
                    }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></Style.Input>
                  {error && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {error}
                    </span>
                  )}
                </div>
              );
            case "phoneNumber":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>
                    {modalTitle === "Add New Contact" &&
                    item.title === "Mobile Phone" ? (
                      <React.Fragment>
                        {" "}
                        {item.title}
                        <span style={{ color: "red" }}>*</span>
                      </React.Fragment>
                    ) : (
                      item.title
                    )}
                  </Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    name={item.title}
                    onChange={(e) => {
                      // handlechange(e);
                      if (item.title === "Mobile Phone") {
                        setRequiredFields({
                          ...requiredFields,
                          [item.title]: e.target.value,
                        });
                      }
                      handlePhoneChange(item.title, e.target.value);
                    }}
                    // onChange={(val) => {
                    //   // console.log("phone with country code=>>", val.target.value)
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     // console.log("value phone..", val);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "phoneNumberA":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {/* <Form.Item label={title} validateStatus={"error"}> */}
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <PhoneNum
                    defaultValue={def}
                    disabled={isDisabled}
                    name={index}
                    onChange={(e) => {
                      handlePhoneChange(item.title, e.target.value);

                      // handlechange(e);
                    }}
                    // onChange={(val) => {
                    //   // console.log("phone with country code=>>", val.target.value)
                    //   if (currentForm) {
                    //     handleInputChange(val, currentForm);
                    //     // console.log("value phone..", val);
                    //     setFormData({
                    //       [index]: val.target.value,
                    //     });
                    //   } else {
                    //     this.setState({
                    //       form: {
                    //         ...this.state.form,
                    //         [index]: val.target.value,
                    //       },
                    //     });
                    //   }
                    // }}
                    size="large"
                    placeholder={`Enter ${title}`}
                    // name="client_primaryContactNumber"
                  ></PhoneNum>
                </div>
              );
            case "currency":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Currency
                    id={index}
                    value={null}
                    placeholder={`Enter ${title}`}
                    name={item.title}
                    onChange={(event) => {
                      event.preventDefault();
                      handleCurrencychange(event);
                    }}></Currency>
                </div>
              );
            case "multiple":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <Style.Input
                    required={isRequired}
                    onChange={(e) => {
                      e.preventDefault();
                      handlechange(e);
                    }}
                    // onChange={(val) =>
                    //   this.setState({
                    //     form: {
                    //       ...this.state.form,
                    //       [index]: val.target.value,
                    //     },
                    //   })
                    // }
                    size="large"
                    placeholder={`Enter ${title}`}
                    name="client_primaryContactNumber"></Style.Input>
                </div>
              );

            case "select":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {console.log("index", index)}
                  <Style.FieldsTitle>
                   {/* {item.title === "Templates" ? (
                      <React.Fragment>
                        {item.title}
                        <span style={{ color: "red" }}>*</span>
                      </React.Fragment>
                   ) : ( */}
                     { item.title}
                  {/* )} */}
                  </Style.FieldsTitle>

                  <Select
                    showSearch
                    placeholder={item.title}
                    name={title}
                    onChange={(value, id, e) => {
                      if (item.title === "Templates") {
                        setRequiredFields({
                          ...requiredFields,
                          [item.title]: value,
                        });
                      }
                      if (item.title === "To Group") {
                        console.log("item.title",value)
                        setRequiredFields({
                          ...requiredFields,
                          ["ToGroup"]: value,
                        });
                      }
                      if (value) {
                        handleSelectChange(index, value);
                        if (index === "Templates") {
                          try {
                            (async () => {
                              setLoading(true);
                              const data = await DEATH_API.fetchEmailTemplates(
                                id.key
                              );
                              setLoading(false);
                              console.log("data for template", data);
                              if (data && data.data.template) {
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  ["Template"]: data.data.template,
                                  ["TemplateID"]: id.key,
                                }));
                                handleSelectTemplateChange(index, id.key);
                                setTemplateDesign(data.data.template);
                              }
                            })();
                          } catch (error) {
                            setLoading(false);
                          }
                        }

                        if (index === "TextTemplates") {
                          console.log("value", value);
                          try {
                            (async () => {
                              setLoading(true);
                              const data = await DEATH_API.fetchTextTemplates(
                                id.key
                              );
                              setLoading(false);

                              console.log(
                                "data for template",
                                data.data.template
                              );
                              if (data && data.data.template) {
                                setFormData((prevFormData) => ({
                                  ...prevFormData,
                                  ["Template"]: data.data.template,
                                  ["TemplateID"]: id.key,
                                }));
                                handleSelectTextTemplateChange(index, id.key);
                                setTemplateDesign(data.data.template);
                              }
                            })();
                          } catch (error) {
                            setLoading(false);
                          }
                        } else {
                          setFormData({
                            [index]: value,
                          });
                        }
                      } else {
                        setFormData({
                          ["TemplateID"]: id.key,
                        });
                      }
                    }}>
                    {index === "TextTemplates" &&
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index === "Templates" &&
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={item.id} value={item.name}>
                            {item.name}
                          </Option>
                        );
                      })}
                    {index !== "Templates" &&
                      index !== "TextTemplates" &&
                      options &&
                      options.map((item, index) => {
                        return (
                          <Option key={index} value={item}>
                            {item}
                          </Option>
                        );
                      })}
                  </Select>
                  {selectListCustomtext && selectListCustomtext[index] && (
                    <div className="custom-field-align">
                      <Input
                        id={`section${index}`}
                        name={title}
                        type="text"
                        placeholder={`Enter ${title}`}
                        size={"large"}
                        onChange={(e) => {
                          // console.log("value....", e.target.value)
                        }}
                      />
                      <Button
                        className="button-set"
                        onClick={() => {
                          const value = document.getElementById(
                            `section${index}`
                          ).value;
                          setFormData({
                            [index]: value,
                          });
                          setselectListCustomtext((prevFormData) => ({
                            ...requiredFields,
                            ...prevFormData,
                            [index]: false,
                          }));
                          // this.setState({
                          //   selectListCustomtext: {
                          //     ...this.state.selectListCustomtext,
                          //     [index]: false,
                          //   },
                          // });
                        }}>
                        OK
                      </Button>{" "}
                    </div>
                  )}
                  {/*      {this.state.textField && <div className="custom-field-align">

                        <Input
                          // id="section"
                          id={`section${index}`}
                          // className="field-set"
                          name={title}
                          type="text"
                          placeholder={`Enter ${title}`}
                          size={"large"}
                          onChange={(e) => {
                            // console.log("value....", e.target.value)
                          }}
                        />
                        <Button
                          className="button-set"
                          onClick={() => {
                            const value = document.getElementById(`section${index}`).value;
                            console.log("value.. saved", value);
                            setFormData({
                              [index]: value,
                            });
                            this.setState({textField:false});
                          }

                          }
                        >
                          OK
                        </Button>{" "}
                        </div>}  */}
                </div>
              );
              case "selectEmail":
                return (
                  <div key={idx} style={{ marginTop: "8px" }}>
                    <Style.FieldsTitle>
                       {  item.title === "To" ? (
                        <React.Fragment>
                          {" "}
                          {item.title}
                          <span style={{ color: "red" }}>*</span>
                        </React.Fragment>
                      ) : (
                        item.title
                      )}
                    </Style.FieldsTitle>
                    <AutoComplete
                      dataSource={options}
                      onSelect={(e)=>{
                      console.log("newvalue",e)
                      handleSelectChange(index, e);
                      setRequiredFields({
                        ...requiredFields,
                        ["To"]: e,
                      });
                      setError(null);
                      }}
                      onSearch={(e)=>{
                        if (!isValidEmail(e)) {
                          setError("Email is invalid");
                        } else {
                          setError(null);
                        }
                        if (item.title === "Email" || item.title === "To") {
                          setRequiredFields({
                            ...requiredFields,
                            ["To"]: e,
                          });
                        }
                        setEmail(e);
                        handleSelectChange(index, e);
                      }}
                    onChange={(e,value)=>{
                    console.log("autocomplte",e,value)
                    }}
                    placeholder="Enter Email"
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                  />
                  {error && (
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {error}
                    </span>
                  )}
                   {/* <Select
                      showSearch
                      placeholder={item.title}
                      mode="tags"
                      name={title}
                      onChange={(value, id, e) => {
                        
                        if (value) {
                          // handleSelectChange(index, value);
                          const selectedValue = value && value.length > 0 ? value[value.length - 1] : null;
                          handleSelectChange(index, selectedValue ? [selectedValue] : []);
                        } 
                      }}>
                      {options &&
                      options.map((item, index) => (
                        <Option key={item.id} value={item.email}>
                          {`${item.firstName} ${item.lastName} - ${item.email}`}
                        </Option>
                      ))
                    }
                    </Select>
                  */}
                  </div>
                );
                case "selectNumber":
                return (
                  <div key={idx} style={{ marginTop: "8px" }}>
                    <Style.FieldsTitle>
                       {item.title}
                    </Style.FieldsTitle>
                    <AutoComplete
                      dataSource={options}
                      onSelect={(e)=>{
                      console.log("newvalue",e)
                      handleSelectChange(index, e);
                      }}
                      onSearch={(e)=>{
                        
                        handleSelectChange(index, e);
                      }}
                    onChange={(e,value)=>{
                    console.log("autocomplte",e,value)
                    }}
                    placeholder="To"
                    filterOption={(inputValue, option) =>
                      option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                  />
                  
                  </div>
                );
  
            case "date":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <DatePicker
                  id="newDate"
                    size="large"
                    style={{ width: "100%", border:"1px solid #d1d5db", borderRadius:"5px", }}
                    format={"MM/DD/YYYY"}
                    placeholder={item.title}
                    name={item.title}
                    onChange={(date, dateString) => {
                      handleDatePickerChange(item.title, dateString);
                      setFormData({
                        [index]: dateString,
                      });
                    }}
                  />
                </div>
              );

            case "textarea":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <TextArea
                    id={index}
                    placeholder={`Enter ${title}`}
                    name={index}
                    onChange={handlechange}
                    // onChange={(e) => {
                    //   handleInputChange(e, currentForm);
                    //   setFormData({
                    //     [index]: e.target.value,
                    //   });
                    // }}
                  />
                </div>
              );

            case "richtext1":
              return (
                <div style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>
                    {" "}
                    {item.title === "Templates" ? (
                      <React.Fragment>
                        {item.title}
                        <span style={{ color: "red" }}>*</span>
                      </React.Fragment>
                    ) : (
                      item.title
                    )}
                  </Style.FieldsTitle>
                  <ReactQuill
                    // readOnly={false}
                    // value={formData[index] || null}
                    value={formData.Template || null}
                    onChange={(e) => {
                      console.log("background", e, formData.Template, index);
                      setFormData((prevFormData) => ({
                        ...prevFormData,
                        [index]: e,
                      }));
                      handleRichTextChange(index, e);
                    }}
                  />
                </div>
              );
              case "richtext2":
                return (
                  <div style={{ marginTop: "8px" }}>
                    <Style.FieldsTitle>
                      {" "}
                      {item.title === "Templates" ? (
                        <React.Fragment>
                          {item.title}
                          <span style={{ color: "red" }}>*</span>
                        </React.Fragment>
                      ) : (
                        item.title
                      )}
                    </Style.FieldsTitle>
                    <ReactQuill
                      // readOnly={false}
                      // value={formData[index] || null}
                      modules={{ toolbar: false }}
                      value={formData.Template || null}
                      onChange={(e) => {
                        console.log("background", e, formData.Template, index);
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          [index]: e,
                        }));
                        handleRichTextChange(index, e);
                      }}
                    />
                  </div>
                );
            case "richtext":
              return (
                <div style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <ReactQuill
                    value={formData.Template || null}
                    // onChange={(e) => {
                    //   handleRichTextChange(index, e, currentForm);
                    //   setFormData({
                    //     [index]: e
                    //   });

                    //   console.log('background', e);
                    // }}
                  />
                </div>
              );

            case "radio":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  {item.title === "*Trusted Individual*" ||
                  item.title === "Second Password Granted" || item.title === "Part of Core Team" ? (
                    <React.Fragment>
                      <div style={{ display: "flex" }}>
                        <Style.FieldsTitle>
                          {modalTitle === "Add New Contact" &&
                          (item.title === "*Trusted Individual*" ||
                            item.title === "Second Password Granted" || item.title === "Part of Core Team") ? (
                            <React.Fragment>
                              {item.title}
                              <span style={{ color: "red" }}>*</span>
                            </React.Fragment>
                          ) : (
                            item.title
                          )}
                        </Style.FieldsTitle>
                        <img
                          style={{
                            cursor: "pointer",
                            marginLeft: "8px",
                            width: "25px",
                            height: "25px",
                            marginTop: "10px",
                          }}
                          src={helpIcon}
                          alt="helpicon"
                          onClick={() => {
                            if (item.title === "*Trusted Individual*") {
                              showTooltipModalTrustee();
                            } else if (
                              item.title === "Second Password Granted"
                            ) {
                              showTooltipModalPassword();
                            }else if (
                              item.title === "Part of Core Team"
                            ) {
                              showTooltipModalTeam();
                            }
                          }}></img>
                      </div>
                    </React.Fragment>
                  ) : (
                    <div style={{ display: "flex" }}>
                      {" "}
                      <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                    </div>
                  )}
                  <Modal
                    centered
                    visible={tooltipModalTrustee}
                    footer={null}
                    onCancel={handleTooltipCancelTrustee}>
                    <Style.ModalTitle> Trusted Individual</Style.ModalTitle>
                    <div style={{}}>
                      <div className="">
                        <Style.ModalDetails>
                          When Trusted Individuals are added, they become
                          “delegates”. Trusted Individuals will receive an
                          invitation email from Asset Planet and if activated,
                          they will have complete access to your information
                          upon your passing. Read more in our Knowledgebase.
                        </Style.ModalDetails>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                    centered
                    visible={tooltipModalPassword}
                    footer={null}
                    onCancel={handleTooltipCancelPassword}>
                    <Style.ModalTitle>
                      {" "}
                      Second Password Granted
                    </Style.ModalTitle>
                    <div style={{}}>
                      <div className="">
                        <Style.ModalDetails>
                          Second Password Granted gives a Trusted Individual
                          access to your List of Password module and your
                          Important Documents module upon entering a valid OTP.
                          These modules are only accessible after your passing.
                          Read more in our Knowledgebase.
                        </Style.ModalDetails>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                  centered
                  visible={tooltipModalTeam}
                  footer={null}
                  onCancel={handleTooltipCancelTeam}>
                  <Style.ModalTitle> Part of Core Team</Style.ModalTitle>
                  <div style={{}}>
                    <div className="">
                      <Style.ModalDetails>
                      Core team may be a Trusted Individual, or not. An example might be a CPA or lawyer.
                      </Style.ModalDetails>
                    </div>
                  </div>
                </Modal>
                  <Radio.Group
                    onChange={(e) => {
                      handleRadioChange(index, e.target.value);
                      if (
                        item.title === "*Trusted Individual*" ||
                        item.title === "Second Password Granted"
                      ) {
                        setRequiredFields({
                          ...requiredFields,
                          [item.title]: e.target.value,
                        });
                      }
                    }}>
                    {["Yes", "No"].map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              );
            case "radio1":
              return (
                <div key={idx} style={{ marginTop: "8px" }}>
                  <div style={{ display: "flex" }}>
                    {" "}
                    <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  </div>

                  <Radio.Group
                    onChange={(e) => {
                      handleRadioChange(index, e.target.value);
                    }}>
                    {["Yes", "No", "50/50"].map((value, vindex) => (
                      <Radio.Button key={vindex} value={value}>
                        {value}
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                </div>
              );
            case "web":
              return (
                <div>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <WebAddress
                    placeholder={`Enter ${title}`}
                    value={formData[index] || null}
                    // onChange={(event) => {
                    //   // console.log("phone",event.target.name);
                    //   // handleWebChange(
                    //   //   index,
                    //   //   event.target.value,
                    //   //   currentForm
                    //   // );
                    //   setFormData({
                    //     [index]: event.target.value,
                    //   });
                    // }}
                    disabled={isDisabled}
                  />
                </div>
              );

            case "document":
              return (
                <div style={{ marginTop: "8px" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="custom-upload-style">
                    <Style.Input
                      id="file-input"
                      type="file"
                      // onChange={(event) => {
                      //   // console.log("document", event.target.files[0]);
                      //   console.log("document size", event.target.files[0].size);
                      //   const fileSize = event.target.files[0].size / (1024 * 1000)// in MB
                      //   console.log("fileSize in mb", fileSize)
                      //   if (fileSize < 100) {
                      //     if (currentForm) {
                      //       handleDocumentChange(
                      //         index,
                      //         event.target.files[0],
                      //         currentForm
                      //       );
                      //       setFormData({
                      //         [index]: event.target.files[0].name,
                      //         file: event.target.files[0]
                      //       });
                      //     } else {
                      //       this.setState({
                      //         form: {
                      //           ...this.state.form,
                      //           [index]: event.target.files[0],
                      //         },
                      //       });
                      //     }
                      //   }
                      //   else {
                      //     swal("Oops!", "File size is large! (Max allowed 100MB)", "error");
                      //   }
                      // }}
                    />
                    <label for="file-input">
                      <Icon
                        className="mt-1"
                        style={{
                          fontSize: "23px",
                          background: "#39b54a",
                          padding: "8px",
                          borderRadius: "5px",
                          color: "white",
                        }}
                        type="upload"></Icon>
                    </label>
                  </div>
                </div>
              );
            case "file":
              return (
                <div style={{ marginTop: "1rem" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id={item.title}
                      type="file"
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose").innerHTML =
                            event.target.files[0].name;
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      // accept="image/jpeg, .pdf, .xlsx, .doc"
                    />
                    <Style.FileLabel
                      htmlFor={item.title}
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose"
                        style={{ marginRight: "10px" }}>
                        No file Choosen{" "}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "Image":
              return (
                <div style={{ marginTop: "1rem" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id={item.title}
                      type="file"
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechoseImage").innerHTML =
                            event.target.files[0].name;
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="image/*"
                    />
                    <Style.FileLabel
                      htmlFor={item.title}
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechoseImage"
                        style={{ marginRight: "10px" }}>
                        No file Choosen{" "}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "video":
              return (
                <div style={{ marginTop: "1rem" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id={item.title}
                      type="file"
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose").innerHTML =
                            event.target.files[0].name;
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="video/*"
                    />
                    <Style.FileLabel
                      htmlFor={item.title}
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose"
                        style={{ marginRight: "10px" }}>
                        No file Choosen{" "}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
            case "audio":
              return (
                <div style={{ marginTop: "1rem" }}>
                  <Style.FieldsTitle>{item.title}</Style.FieldsTitle>
                  <div className="">
                    <Style.Input
                      // id="file-input"
                      id={`${item.title}1`}
                      type="file"
                      name={item.title}
                      // onChange={(e)=>{handlechange(e)}}
                      style={{
                        width: "80%",
                        display: "none",
                        marginRight: "10px",
                      }}
                      onChange={(event) => {
                        // console.log("document", event.target.files[0]);
                        console.log(
                          "document size",
                          event.target.files[0].size
                        );
                        const fileSize =
                          event.target.files[0].size / (1024 * 1000); // in MB
                        console.log("fileSize in mb", fileSize);
                        if (fileSize < 100) {
                          handleDocumentChange(
                            item.title,
                            event.target.files[0]
                          );
                          document.getElementById("filechose1").innerHTML =
                            event.target.files[0].name;
                        } else {
                          swal(
                            "Oops!",
                            "File size is large! (Max allowed 100MB)",
                            "error"
                          );
                        }
                      }}
                      accept="audio/*"
                    />
                    <Style.FileLabel
                      htmlFor={`${item.title}1`}
                      style={{ width: "100%" }}
                      className="file">
                      <Style.FileBlock
                        id="filechose1"
                        style={{ marginRight: "10px" }}>
                        No file Choosen{" "}
                        <img src={fileIcon} alt="fileIcon"></img>
                      </Style.FileBlock>
                      <Style.FileBlockButton>Browse</Style.FileBlockButton>{" "}
                    </Style.FileLabel>
                  </div>
                </div>
              );
          }
        })}
      </div>

      <Style.WrapperButtons>
        <Style.CancelButton
          onClick={() => {
            close();
            setFormData({});
          }}>
          Cancel
        </Style.CancelButton>
        <Style.SaveButton
          // disabled={
          //   (modalTitle === "Add New Contact" &&
          //     (!requiredFields ||
          //       !(
          //         requiredFields["First Name"] &&
          //         requiredFields["Last Name"] &&
          //         requiredFields["Phone"] &&
          //         requiredFields["Email"] &&
          //         requiredFields["*Trusted Individual*"] &&
          //         requiredFields["Second Password Granted"]
          //       ))) ||
          //   (modalTitle === "Add New Email" &&
          //     (!requiredFields ||
          //       !(
          //         requiredFields["To"] &&
          //         requiredFields["Templates"] &&
          //         requiredFields["Body of Email"] &&
          //         requiredFields["Subject"]
          //       )))
          // }
          disabled={
            (modalTitle === "Add New Email" &&
              (requiredFields &&
             ( requiredFields["To"]  || requiredFields["ToGroup"] )
              // &&
              // requiredFields["Subject"]
                ? false
                : true)) ||
            (modalTitle === "Add New Contact" &&
              (requiredFields &&
              requiredFields["First Name"] &&
              requiredFields["Last Name"] &&
              requiredFields["Mobile Phone"] &&
              requiredFields["Email"] &&
              requiredFields["*Trusted Individual*"] &&
              requiredFields["Second Password Granted"]
                ? false
                : true))
          }
          onClick={handleSubmit}>
          Save
        </Style.SaveButton>
      </Style.WrapperButtons>
      <Loader isLoading={loading} />
    </Modal>
  );
}

export default AddModal;
